export default "__VITE_ASSET__nyZnnIRx__"